import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProductCard.css';
import { ShoppingCart } from "lucide-react";
import { useUser } from '../contexts/UserContext';
import MiniCart from './MiniCart';
import AuthModal from './AuthModal';


export default function ProductCard({ item, onAddToCart, onToggleFavorite, isFavorite, showMinitsLabel }) {
  const navigate = useNavigate();
  const { user, addToCart, loadCart } = useUser();
  const [showMiniCart, setShowMiniCart] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const frontImage = (item.files || []).find(f => f.for_show && f.type === 'image') || (item.files || []).find(f => f.type === 'image') || (item.url ? { url: item.url } : null);
  const price = item.price || 0;
  const salePrice = item.sale_price;
  const isOnSale = salePrice !== null && salePrice !== undefined;
  const name = item.name || '';
  const short = item.short_description || '';

  const handleCardClick = () => {
    navigate(`/item/${item.id}`);
  };

  const handleAddToCart = async (e) => {
    e.stopPropagation();
    if (!user) {
      setShowAuthModal(true);
      return;
    }
    try {
      await addToCart(item);
      await loadCart();
      setShowMiniCart(true);
      setTimeout(() => setShowMiniCart(false), 6000);
    } catch (err) {
      console.error('שגיאה בהוספה לסל', err);
    }
  };

  const handleDetails = (e) => {
    e.stopPropagation();
    navigate(`/item/${item.id}`);
  };

  const handleFavorite = (e) => {
    e.stopPropagation();
    if (onToggleFavorite) onToggleFavorite(item);
  };

  // צבעי רקע לפי סוג
  const bgColor = item.backgroundColor || '#f0f0f0';
  const borderColor = item.borderColor || bgColor;

  return (
    <>
      <div className="home-product-card" onClick={handleCardClick}>
        <div className="home-card-inner" style={{ backgroundColor: bgColor, borderColor: borderColor }}>
          <div className="home-card-image-wrapper">
            {frontImage ? (
              <img src={frontImage.url} alt={name} className="home-card-image" />
            ) : (
              <div className="home-card-placeholder">אין תמונה</div>
            )}
            {isOnSale && (
              <div className="home-sale-badge">במבצע!</div>
            )}
            {onToggleFavorite && (
              <button className="home-favorite-btn" onClick={handleFavorite} aria-label={isFavorite ? 'הסר מהמועדפים' : 'הוסף למועדפים'}>
                {isFavorite ? '❤️' : '🤍'}
              </button>
            )}
          </div>
          <div className="home-card-footer">
            <div className="home-card-program-name">{name}</div>
            <div className="home-card-info-row">
              <div className="home-card-info-right">
                <div className="home-card-description">
                  {short}
                </div>
              </div>
              <div className={`home-card-price ${!isOnSale ? 'price-bold' : ''}`}>
                {isOnSale ? (
                  <>
                    <div className="home-card-original-price">{price}₪</div>
                    <div className="home-card-sale-price">{salePrice}₪</div>
                  </>
                ) : (
                  <>{price}₪</>
                )}
              </div>
            </div>
            <div className="home-card-buttons">
              <button className="home-btn-add-cart" onClick={handleAddToCart}>
                <ShoppingCart size={18} marginLeft={8} /> הוסף לסל
              </button>
              <button className="home-btn-details" onClick={handleDetails}>
                כל הפרטים
              </button>
            </div>
          </div>
        </div>
      </div>
      {showMiniCart && (
        <MiniCart
          isOpen={showMiniCart}
          items={user?.cart || []}
          onClose={() => setShowMiniCart(false)}
          onGoToCart={() => { setShowMiniCart(false); navigate('/profile/cart'); }}
        />
      )}
      {showAuthModal && <AuthModal onClose={() => setShowAuthModal(false)} />}
    </>
  );
}



